import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './EmailSignup.css';

const EmailSignup: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<'success' | 'error' | ''>('');

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      setMessage('Please enter your email address');
      setMessageType('error');
      return;
    }

    if (!validateEmail(email)) {
      setMessage('Please enter a valid email address');
      setMessageType('error');
      return;
    }

    setMessage('');
    const q = encodeURIComponent(email.trim().toLowerCase());
    navigate(`/signup?email=${q}`);
  };

  return (
    <div className="email-signup">
      <form onSubmit={handleSubmit} className="email-signup-form">
        <div className="email-input-container">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="email-input"
            required
          />
          <button type="submit" className="signup-button" disabled={!email.trim()}>
            Sign Up
          </button>
        </div>
        
        {message && (
          <div className={`signup-message ${messageType}`}>
            {message}
          </div>
        )}
      </form>
      
      <p className="signup-description">
        Sign up to receive early access to our platform, free application materials, and notifications about
        when the Future Leaders Fellowship application opens.
      </p>
    </div>
  );
};

export default EmailSignup;
